import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import SideBar4 from '../../components/Sidebar/SideBar4';
// import useFetchRoles from '../../hooks/fetchRoles';
import useFetchPermissions from '../../hooks/fetchPermissions';
import { Pagination } from 'antd';
import { app } from '../../config';
import Navbar from '../../components/Navbars/Navbar';
const Permissions = () => {
  const { t } = useTranslation(['common']);
  let navigate = useNavigate();
  let perm = useFetchPermissions();
  let permCount = perm.response?perm.response.data.length:"";
  let permResponse=[];
  console.log('🚀 ~ file: Permissions.js:16 ~ Permissions ~ perm', perm.response);
  const [editbtn, setEditBtn] = useState('none');
  const [search, setSearch] = useState('');
  const [current, setCurrent] = useState(1);
  const [searchShow, setSearchShow] = useState(false);
  const [renderList, setRenderList] = useState([]);
  const [tableShow, setTableShow] = useState(true);
  const [err, setErr] = useState('');
  let searchedUser;
  const editPerm = (e) => {
    console.log(e);
    localStorage.setItem('permissionId', JSON.stringify(e.permId));
    navigate('/permission/edit', { replace: true });
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user.userType === 'A') setEditBtn('block');
    const fetchPerms=async()=>{
      const limit=10;
      const offset=0;
      permResponse=await axios.post(`${app.URL}/perm/viewperms`,{limit,offset});
      console.log(permResponse);
      console.log(permResponse.data.data);
      // permResponse.data?setOrgsResp(permResponse.data.data):" ";
      permResponse.data?setRenderList(permResponse.data.data):console.log("Not Set");
      }
      fetchPerms();
  }, []);
  const handleSearch = async () => {
    try {
      const result = search ? await axios.get(`${app.URL}/user/search/${search}`) : [];
      searchedUser = result.data;
    } catch (e) {
      console.log('Error');
      if (e.message) setErr(e.response.data.message);
      setTableShow(false);
    }

    console.log(searchedUser);
    if (searchedUser) {
      setSearchShow(true);
      setRenderList(searchedUser);
    }
    console.log(searchedUser);
  };
  const handleSearchChange = (e) => {
    if (!e.target.value) {
      setRenderList(permResponse.data);
      setTableShow(true);
    }
    setSearch(e.target.value);
  };
  // useEffect(() => {
  //   if (!searchShow) setRenderList(permResponse.data);
  // }, [handleSearch]);

  const onChange = async(page,pageSize) => {
    console.log(page,pageSize);
    setCurrent(page);
    if(!page)page=1;
    let limit=pageSize;
    let reqObj={
      limit,
      offset:limit*(page-1)
    }
    console.log(reqObj);
    const permResp=await axios.post(`${app.URL}/perm/viewperms`,reqObj);
    console.log(permResp.data);
    if(permResp.data){
      setRenderList(permResp.data.data)
    }
  };
  return (
    <div class='container colorbg m-0 pl-0' style={{ maxWidth: '100%' }}>
      <div class='row'>
        <Navbar />
      </div>
      <div class='row '>
        <div class='col-sm-3' style={{ width: '25%', marginLeft: '0px' }}>
          <SideBar4 />
        </div>
        {/* <div class="col-lg-6 mt-4 "> */}
        <div class='container w-75'>
          <div class='row'>
            <div class='col mt-3'>
              <div class='input-group ml-60' style={{ width: '40%' }}>
                <input type='search' class='form-control rounded w-50' placeholder='Search' aria-label='Search' aria-describedby='search-addon' onChange={handleSearchChange} />
                <button type='button' class='btn btn-outline-primary color1 button text-white' onClick={handleSearch}>
                  search
                </button>
              </div>
            </div>
          </div>
          <div class='row'>
            <h1 class='col fw-bold fs-3 text-black mt-3 mb-3 '>{t('Permissions')}</h1>
            <h1 style={{ display: tableShow ? 'none' : 'block' }}>{err}</h1>
            <div class='row'>
              <div class='col-lg-11'>
                <div class='table-responsive '>
                  {/* style={{display:tableShow?"block":"none"}} */}
                  <table class='table styled-table'>
                    <thead class='thead-light'>
                      <tr>
                        <th>{t('ID')}</th>
                        <th>{t('Label')}</th>
                        <th>{t('Route')}</th>
                        <th>{t('Created On')}</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {renderList
                        ? renderList.map((output) => (
                            <tr>
                              <td>{output.permId}</td>
                              <td>{output.label}</td>
                              <td>{output.route}</td>
                              <td>{output.createdOn}</td>
                              <td>
                                <button type='button' style={{ display: editbtn }} class='btn btn-primary color1 button' onClick={() => editPerm(output)}>
                                  {t('Edit')}
                                </button>
                              </td>
                              {/* <td></td> */}
                            </tr>
                          ))
                        : ' '}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <Pagination style={{marginTop:"10px"}} onChange={onChange} defaultCurrent={current} total={permCount} />
        </div>
      </div>
      {/* </div> */}
    </div>
  );
};

export default Permissions;
